// extracted by mini-css-extract-plugin
export default {"melodyVideo":"JQ-z","isFullWidth":"KQ-z","landingPageVideo":"LQ-z","play":"MQ-z","iframeVideo":"NQ-z","playHidden":"OQ-z","fullwidth":"PQ-z"};